module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-king.f060f83a.svg";